const InputFieldV2 = ({
                      field,
                      value,
                      onChange,
                      error,
                      disabled,
                      disabledHint
                    }) => {
  return (
    <fieldset className="relative border border-light-grey-color h-12 rounded-md group">
      <legend className="mx-3 px-1 text-xs">
        {field.label} {field.required && "*"}
      </legend>

      <input
        name={field.key}
        value={value || ""}
        onChange={onChange}
        disabled={disabled}
        className={`w-full h-full px-4 bg-transparent outline-none text-sm
          ${disabled ? "cursor-not-allowed text-gray-400" : ""}
        `}
      />

      {/* TOOLTIP */}
      {disabled && disabledHint && (
        <div className="absolute -top-9 left-2 hidden group-hover:block z-50">
          <div className="bg-black text-white text-xs px-2 py-1 rounded shadow">
            {disabledHint}
          </div>
        </div>
      )}

      {error && (
        <p className="text-red-500 text-xs px-4 mt-1">{error}</p>
      )}
    </fieldset>
  );
};

export default InputFieldV2;
